import 'angular:locale/data:ko';
import 'angular:locale/data:hi';
import 'angular:locale/data:yue';
import 'angular:locale/data:zh';
import 'angular:locale/data:ja';
import 'angular:locale/data:de';
import 'angular:locale/data:pl';
import 'angular:locale/data:vi';
import 'angular:locale/data:th';
import 'angular:locale/data:id';
import 'angular:locale/data:ar';
import 'angular:locale/data:es';
import 'angular:locale/data:fr';
import 'angular:locale/data:en';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
